import { render, staticRenderFns } from "./study-psctoken.vue?vue&type=template&id=7c7e863f&"
import script from "./study-psctoken.vue?vue&type=script&lang=js&"
export * from "./study-psctoken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports